import React from "react";
import "../GalleryComponent/GalleryComponentCss/SchoolSocialSection.css";

import img1 from "../Images/school1.jpg";
import img2 from "../Images/school2.jpg";
import img3 from "../Images/school3.jpg";
import img4 from "../Images/school4.jpg";
import img5 from "../Images/school5.png";
import img6 from "../Images/school6.png";
import img7 from "../Images/school7.jpg";
import img8 from "../Images/school8.jpg";


export default function SchoolSocialSection() {
  return (
    <section className="school-social-section">
      <h2 className="school-social-title">शाळा उपक्रम</h2>

      <div className="school-social-grid">

        {/* Left Big Image */}
        <img src={img1} alt="event" className="school-img big-img" />

        {/* Right Image Grid */}
        <div className="right-grid">

          {/* Row 1 - Two Small Images */}
          <div className="top-small-row">
            <img src={img2} alt="event" className="school-img small-img" />
            <img src={img3} alt="event" className="school-img small-img" />
          </div>

          {/* Middle Wide Image */}
          <div className="middle-wide-row">
            <img src={img4} alt="event" className="school-img wide-img" />
          </div>

          
        </div>
         
      </div>
      {/* Row 2 - Two Small Images (Corrected to match photo) */}
          <div className="bottom-small-row">
            <img src={img5} alt="event" className="school-img wide-img" />
            <img src={img6} alt="event" className="school-img wide-img" />
             <img src={img7} alt="event" className="school-img wide-img" />
            <img src={img8} alt="event" className="school-img wide-img" />
             
            
          </div>

    </section>
  );
}
